import { render, staticRenderFns } from "./charHB.vue?vue&type=template&id=3a4b4bdd&scoped=true"
import script from "./charHB.vue?vue&type=script&lang=js"
export * from "./charHB.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4b4bdd",
  null
  
)

export default component.exports